import { render, staticRenderFns } from "./MIoTCard.vue?vue&type=template&id=0f28556a"
import script from "./MIoTCard.vue?vue&type=script&lang=js"
export * from "./MIoTCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports